import { render, staticRenderFns } from "./component.vue?vue&type=template&id=3995b152&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3995b152')) {
      api.createRecord('3995b152', component.options)
    } else {
      api.reload('3995b152', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=3995b152&", function () {
      api.rerender('3995b152', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/fullscreen/component.vue"
export default component.exports